// src/pages/Splash.js
import { useEffect } from 'react';
import { LogoMark } from '../components/Icon';
import { C, FONTS } from '../styles/theme';

export function Splash({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: C.bg,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 28,
      animation: 'fadeOut 0.5s ease 1.9s forwards',
    }}>
      <div className="anim-pop-in" style={{ animationDelay: '0.1s' }}>
        <LogoMark size={96}/>
      </div>
      <div className="anim-slide-up" style={{ animationDelay: '0.3s', textAlign: 'center' }}>
        <div style={{ fontFamily: FONTS.display, fontSize: 52, color: C.text, letterSpacing: '-1px', fontStyle: 'italic' }}>
          Messy
        </div>
        <div style={{ fontSize: 13, color: C.textLight, marginTop: 6, letterSpacing: '0.08em' }}>
          from the Saxe Club
        </div>
      </div>
    </div>
  );
}
